<h1 class="fd-subtitle">{{actionType}} FINALIZADA</h1>
<h4 class="fd-subtitle-2">FECHE A JANELA PARA VOLTAR PARA O SICRD</h4>
